import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const ItemList = styled.div `
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, 1fr);

  @media ${from(Device.TabletLarge)} {
    gap: 30px;
  }

  [data-layout='2column'] & {
    @media ${from(Device.Tablet)} {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  [data-layout='3column'] & {
    @media ${from(Device.Tablet)} {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  [data-layout='4column'] & {
    @media ${from(Device.Tablet)} {
      grid-template-columns: repeat(4, 1fr);
    }
  }
`;
const Item = styled.div `
  display: flex;
  min-height: 200px;

  @media ${from(Device.DesktopMedium)}
  {
    min-height: 365px;
  }

`;
export default {
    Container,
    Item,
    ItemList,
};
